<template lang="pug">
  .card.post_media_modal_card
    template(v-if="activePage === 'detail'")
      .post_media_modal_content
        .title.is-3 {{ title }}
        .post_media_modal_tabs
          b-tabs(
            v-model="activeTab"
            size="is-medium"
            type="is-boxed")
            // 画像一覧
            b-tab-item.post_media_list(icon="images" label="画像一覧")
              .post_media_list_main(v-if="isMediaListShown")
                .post_media_list_search
                  b-field
                    b-input(
                      v-model="searchForm.key"
                      placeholder="キーワードで検索"
                      type="search"
                      icon="search"
                      rounded
                      size="is-medium"
                      @input="getMediaList('search')")
                #js_post_media_list_content.post_media_list_content
                  b-loading(v-model="infiniteScroll.isLoading" :is-full-page="media.isFullPage")
                  ul#js_post_media_list_list.post_media_list_list(v-if="mediaList.length > 0")
                    li.post_media_list_item(v-for="(media, index) in mediaList")
                      .card(:class="{ 'is_active':  selectedMedia.data != null && media.id == selectedMedia.data.id }")
                        .card-image(@click="selectMedia(index)")
                          .image(:style="'background-image: url('+media.url+')'")
                  .post_media_list_empty(v-show="mediaList.length === 0 && !infiniteScroll.isLoading") 該当する画像はありません
              #js_post_media_list_detail.post_media_list_detail(v-if="isMediaDetailShown")
                template(v-if="selectedMedia.data != null")
                  .post_media_list_detail_content
                    b-loading(v-model="media.panel.isLoading" :is-full-page="media.panel.isFullPage")
                    figure.image.mb-4
                      img(:src="selectedMedia.data.url")
                    p.is-size-5
                      span.has-text-weight-bold ファイル名：
                      span {{ selectedMedia.data.name }}
                    p.is-size-5
                      span.has-text-weight-bold サイズ：
                      span {{ selectedMedia.size.width }} × {{ selectedMedia.size.height }} px
                    b-switch.mt-4(
                      v-model="selectedMedia.data.release_flag"
                      size="is-medium"
                      @input="updateImage(selectedMedia.data.release_flag,selectedMedia.data.id )") {{ selectedMedia.data.release_flag === true ? 'メディア一覧にのせる' : 'メディア一覧にのせない' }}
                    b-field.mt-4.has-addons(v-if="selectedMedia.data.url")
                      b-input(v-model="selectedMedia.data.url" readonly expanded)
                      p.control
                        b-button(
                          type="is-primary"
                          v-clipboard:copy="selectedMedia.data.url"
                          v-clipboard:success="onCopySuccess"
                          v-clipboard:error="onCopyError") Copy
                    .post_media_list_detail_buttons.mt-5
                      b-button.media_modal_edit(
                        type="is-info"
                        size="is-medium"
                        outlined
                        icon-left="image-edit"
                        @click="switchPage('edit')") 編集する
                      b-button.media_modal_duplicate(
                        type="is-info"
                        size="is-medium"
                        outlined
                        icon-left="copy"
                        :loading="selectedMedia.duplicate.isLoading"
                        @click="duplicateConfirm()") 複製する
                    .post_media_list_detail_delete.mt-6
                      a.has-text-danger(@click="deleteImageConfirm(selectedMedia.data.id)") 削除する
            // アップロード
            b-tab-item.post_media_uploader(icon="image-upload" label="画像アップロード")
              b-upload(
                v-if="!uploader.isLoading"
                v-model="uploader.file"
                drag-drop
                expanded
                accept="image/jpeg, image/png, image/gif"
                size="is-medium")
                section.section
                  .content.has-text-centered
                    p
                      b-icon(icon="image-upload")
                    p.is-size-5
                      | アップロードするファイルをドロップ
                      br
                      | または
                      br
                      | ファイルを選択
              .post_media_uploader_content
                .post_media_uploader_file_name.mt-6(v-if="uploader.file" :class="uploader.className")
                  p
                    span.has-text-weight-bold ファイル名：
                    span {{ uploader.file.name }}
                b-switch.mt-5(v-model="uploader.release_flag" size="is-medium" width="20")
                  span(v-html="isMediaMessage")
                b-button.is-block.mt-6(
                  v-if="uploader.file"
                  type="is-info"
                  size="is-medium"
                  :loading="uploader.isLoading"
                  :class="uploader.buttonClassName"
                  @click="uploadImage()") 画像をアップロードする
        .post_media_modal_footer
            // sp & tablet device only
            .post_media_modal_footer_switch
              template(v-if="activeTab === 0")
                b-button._spDisp._text_decoration_none(
                  v-if="isMediaListShown"
                  type="is-text"
                  size="is-medium"
                  outlined
                  icon-left="image-search"
                  :disabled="selectedMedia.data === null"
                  @click="switchMediaContent()") 詳細を見る
                b-button._spDisp._text_decoration_none(
                  v-if="isMediaDetailShown"
                  type="is-text"
                  size="is-medium"
                  outlined
                  icon-left="arrow-circle-left"
                  :disabled="selectedMedia.data === null"
                  @click="switchMediaContent()") 一覧に戻る
            // all device
            b-button(
              v-if="modalType === 'thumbnail'"
              type="is-info"
              size="is-medium"
              :disabled="selectedMedia.data === null"
              @click="setToThumbnail(selectedMedia.data.url)") アイキャッチに設定する
            b-button(
              v-else-if="modalType === 'imageInArticle'"
              type="is-info"
              size="is-medium"
              :disabled="selectedMedia.data === null"
              @click="insertImageInArticle(selectedMedia.data.url)") 記事内に画像を挿入する
    template(v-else)
      image-editor(
        :mediaData="selectedMedia"
        @switchMediaModalPage="switchPage"
        @getMediaList="getMediaList('save')")
</template>

<script>
import ImageEditor from '@/components/ImageEditor.vue'

export default {
  name: 'PostMediaModal',
  components: {
    ImageEditor
  },
  data: function(){
    return {
      mediaList: new Array(),

      title: null,
      activeTab: 0, // 画像一覧 or アップロード
      activePage: 'detail', // 画像一覧・詳細 or 画像編集
      isMediaMessage: 'メディア一覧にのせない',

      media: {
        index: null, // 選択中の画像のindex
        panel: {
          isLoading: false,
          isFullPage: false
        },
        isFullPage: false
      },

      selectedMedia: {
        data: null,
        size: {
          width: 0,
          height: 0
        },
        duplicate: {
          isLoading: false,
        },
      },

      uploader: {
        file: null,
        release_flag: false,
        isLoading: false,
        className: null,
        buttonClassName: null,
      },

      /* メディア一覧・詳細 切り替え */
      mql: null,
      isMediaListShown: true,
      isMediaDetailShown: true,

      /* 絞り込みフォーム */
      searchForm: {
        key: ""
      },

      /* 記事一覧 無限スクロール */
      infiniteScroll: {
        limit: 40,
        offset: 0,
        display: 0, // 一覧に現在表示している数
        keyword: '',
        isLastPage: false, // 無限スクロール終了時にtrue
        isLoading: false,
      }
    }
  },
  props: [
    'isModalActive',
    'modalType' // アイキャッチ or 記事内画像
  ],
  created() {
    this.getMediaList()

    if ( this.modalType == 'thumbnail' ) {
      this.title = 'アイキャッチ画像'
    } else if ( this.modalType == 'imageInArticle' ) {
      this.title = '記事内に画像を挿入'
    }
  },
  mounted() {
    this.uploader.file = null

    this.mql = window.matchMedia( '(max-width: 960px)' )
    this.mql.addListener(this.setMediaContent)
    this.setMediaContent()

    window.addEventListener('resize', this.adaptScrollContentHeight)
    this.adaptScrollContentHeight()

    this.setInfiniteScroll()
  },
  destroyed(){
    window.removeEventListener('resize', this.adaptScrollContentHeight)
  },
  watch: {
    'searchForm.key'(){
      this.getMediaList('search')
    },
    'afterRelatedArticleList'(list) {
      this.isRelatedArticleFilled = (list.length >= 3) ? true : false
    },
    'uploader.file': function(){
      this.uploader.className = 'animated_opacity'
      this.uploader.buttonClassName = 'animated_bound'
      setTimeout(
        function() {
          this.$nextTick(function(){
            this.uploader.className = null
            this.uploader.buttonClassName = null
          })
        }.bind(this),
        500 // .animated_bound の animation-durationより長く
      )
    },
    'uploader.release_flag': function(v){
      this.isMediaMessage = v ? 'メディア一覧にのせる' : 'メディア一覧にのせない'
    },
    'activeTab'(tab){
      if( tab == 1 ){
        this.selectedMedia.data = null
        const content = document.getElementById('js_post_media_list_content')
        if( content ) content.scrollTo(0, 0)
      }
      if( this.mql.matches ) {
        this.isMediaListShown = true
        this.isMediaDetailShown = false
      }

      if( tab == 0 && this.mql.matches ) {
        this.adaptScrollContentHeight()
      }
    },
    'activePage'() {
      this.adaptScrollContentHeight()
    },
    'isMediaListShown'() {
      this.adaptScrollContentHeight()
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    switchPage(pageType) {
      this.activePage = pageType
      if( pageType === 'detail' ) {
        this.getImageSize()
      }
    },
    setMediaContent() {
      if( this.mql.matches ) {
        this.isMediaDetailShown = false
      } else {
        this.isMediaListShown = true
        this.isMediaDetailShown = true
      }
    },
    switchMediaContent() {
      this.isMediaListShown = !this.isMediaListShown
      this.isMediaDetailShown = !this.isMediaDetailShown
      if(this.isMediaDetailShown) this.setInfiniteScroll()
    },
    adaptScrollContentHeight() {
      this.$nextTick(function() {
        const content = document.getElementById('js_post_media_list_content')
        const detailContent = document.getElementById('js_post_media_list_detail')
        const windowHeight = window.innerHeight

        if( content ) {
          if( this.mql.matches ) {
            content.style.cssText = 'height: calc(' + windowHeight + 'px - 150px);' // 画面の高さ - 上コンテンツ分の高さ
          } else {
            content.style.cssText = 'height: 500px;'
          }
        }

        if( detailContent ) {
          if( this.mql.matches ) {
            detailContent.style.cssText = 'height: calc(' + windowHeight + 'px - 120px);' // 画面の高さ - 上コンテンツ分の高さ
          } else {
            detailContent.style.cssText = 'height: 540px;' // 40px（キーワード検索の高さ） + 500px（画像一覧の高さ）
          }
        }
      })
    },
    selectMedia(index) {
      this.media.index = index
      this.selectedMedia.data = this.mediaList[index]
      this.getImageSize()
    },
    getImageSize(){
      this.media.panel.isLoading = true
      const img = new Image()
      img.crossOrigin = "anonymous"
      img.src = this.selectedMedia.data.url

      img.onload = () => {
        this.selectedMedia.size.width = img.width
        this.selectedMedia.size.height = img.height

        this.media.panel.isLoading = false
      }
    },
    duplicateConfirm(){
      this.$buefy.dialog.confirm({
        title: '画像を複製しますか？',
        message: '複製した画像は一覧の最上部に追加されます。',
        confirmText: '複製する',
        cancelText: 'キャンセル',
        type: 'is-info',
        size: 'is-medium',
        hasIcon: false,
        onConfirm: () => {
          this.duplicateImage()
        }
      })
    },
    deleteImageConfirm(id){
      this.$buefy.dialog.confirm({
        title: '画像を削除しますか？',
        message: '削除した画像は復元できません。',
        confirmText: '画像を削除する',
        cancelText: 'キャンセル',
        type: 'is-danger',
        size: 'is-medium',
        hasIcon: true,
        icon: 'exclamation-circle',
        onConfirm: () => {
          this.changedContent = false
          this.deleteImage(id)
        }
      })
    },
    onCopySuccess(){
      this.$buefy.toast.open({
        duration: 2000,
        message: 'URLをコピーしました',
        type: 'is-success'
      })
    },
    onCopyError(){
      this.$buefy.toast.open({
        duration: 2000,
        message: 'URLのコピーに失敗しました',
        type: 'is-danger'
      })
    },
    insertImageInArticle(url){
      this.$emit( 'insertImageInArticle', url )
    },
    setToThumbnail(url) {
      this.$emit( 'setToThumbnail', url )
    },
    setInfiniteScroll() {
      this.$nextTick(function() {
        const mediaListContent = document.getElementById('js_post_media_list_content')
        if( mediaListContent ) {
          mediaListContent.addEventListener( 'scroll', this.mediaScroll )
        }
      })
    },
    mediaScroll() {
      const elm = document.getElementById('js_post_media_list_content')
      const list = document.getElementById('js_post_media_list_list')

      const HeightAdjustment = 80
      if( elm && !this.infiniteScroll.isLastPage ){
        // 最下部の画像が画面に入ったら次のページを読み込む
        if( list.getBoundingClientRect().bottom < elm.getBoundingClientRect().bottom + HeightAdjustment ){
          if(this.infiniteScroll.isLoading === false){
            this.getMediaList('scroll')
          }
        }
      }
    },
    async getMediaList(type) {
      try {
        this.infiniteScroll.isLoading = true

        if( type !== 'scroll' ) this.infiniteScroll.offset = 0

        const data_obj = {
          keyword: this.searchForm.key,
          limit: this.infiniteScroll.limit,
          offset: this.infiniteScroll.offset,
        }

        const res = await this.$axios.get(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES,
          { params: data_obj }
        )

        const r = res.data
        if( r.status == 1 ){
          const data = r.data

          if( type === 'search' || type === 'upload' ) { // キーワード検索
            this.mediaList = data
          } else if( type === 'duplicate' || type === 'save' || type === 'delete' ) { // 複製・編集して保存・削除
            this.mediaList = new Array()

            this.$nextTick(function() {
              this.mediaList = data

              // 一覧画像キャッシュ対策
              const current_unixtime = Date.now()
              this.mediaList[this.media.index].url += ('?time=' + current_unixtime)
            })
          } else {
            this.mediaList = this.mediaList.concat(data)
          }

          this.$nextTick(function() {
            this.infiniteScroll.offset += this.infiniteScroll.limit

            // 画像一覧の総数＝該当の画像の総数となった時点で、無限スクロールストップ
            this.infiniteScroll.isLastPage = ( this.mediaList.length === r.meta.total_count ) ? true : false

            const mediaListContent = document.getElementById('js_post_media_list_content')

            if( type !== 'scroll' ) {
              mediaListContent.scrollTo(0, 0)
            }

            if( type === 'search' ) {
              this.selectedMedia.data = null
            } else if( type === 'upload' || type === 'duplicate' ) {
              this.selectedMedia.data = this.mediaList[0]
              this.getImageSize()
            } else if (type === 'save') {
              this.selectedMedia.data = this.mediaList[this.media.index]
            }
          })
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '画像一覧の取得に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.infiniteScroll.isLoading = false
      }
    },
    async uploadImage() {
      try {
        this.uploader.isLoading = true
        const formData = new FormData()
        formData.append('image[image]', this.uploader.file)
        formData.append('image[release_flag]', this.uploader.release_flag)

        const config = { headers: {"Content-Type": "multipart/form-data"} }

        const res = await this.$axios.post(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES,
          formData,
          config
        )

        const r = res.data
        if( r.status == 1 ){
          this.uploader.file = null
          this.$common.createSuccessMessage('画像をアップロードしました')
          setTimeout(
            function() {
              this.$nextTick(function(){
                this.activeTab = 0

                this.getMediaList('upload')
              })
            }.bind(this),
            300
          );
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else if(r.errors.status == 58) {
            this.$common.createErrorMessage(r.errors, '画像のアップロードは「.jpg形式、.jpeg形式、.gif形式、.png形式」のみ対応しています。')
          } else {
            this.$common.createErrorMessage(r.errors, '画像のアップロードに失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.uploader.isLoading = false
      }
    },
    async duplicateImage() {
      try {
        this.selectedMedia.duplicate.isLoading = true

        const fileName = this.selectedMedia.data.name
        const index = fileName.indexOf('.')
        const extension = fileName.slice(index + 1)
        const mineType = (function() {
          if ( extension === 'png' ) {
            return 'image/png'
          } else if( extension === 'jpeg' || extension === 'jpg' ) {
            return 'image/jpeg'
          } else if( extension === 'gif' ) {
            return 'image/gif'
          }
        })();

        const toDataURL = url => fetch(url)
          .then(response => response.blob())
          .then(blob => new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          }))

        const base64 = await toDataURL(this.selectedMedia.data.url)

        const bin = atob(base64.replace(/^.*,/,''))
        const buffer = new Uint8Array(bin.length)
        for (let i = 0; i < bin.length; i++) {
          buffer[i] = bin.charCodeAt(i)
        }
        const file = new File([buffer.buffer], fileName ,{ type: mineType })

        const config = { headers: {"Content-Type": "multipart/form-data"} }

        const formData = new FormData()
        formData.append('image[image]', file)
        formData.append('image[release_flag]', false) // 複製なのでfalse

        const res = await this.$axios.post(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES,
          formData,
          config
        )

        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage('画像を複製しました')
          this.getMediaList('duplicate')
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '画像の複製に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      } finally {
        this.selectedMedia.duplicate.isLoading = false
      }
    },
    async updateImage(release_flag, id) {
      try{
        const formData = new FormData()
        formData.append('image[release_flag]', release_flag)

        const config = { headers: {"Content-Type": "multipart/form-data"} }

        const res = await this.$axios.put(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES_.replace(':id', id),
          formData,
          config
        )
        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage('画像情報を更新しました')
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '画像情報の更新に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
    async deleteImage(id) {
      try{
        const res = await this.$axios.delete(
          process.env.VUE_APP_API_ENDPOINT
          + process.env.VUE_APP_API_BASE_PATH
          + this.$constants.API_PATH.IMAGES_.replace(':id', id)
        )
        const r = res.data
        if( r.status == 1 ){
          this.$common.createSuccessMessage('画像を削除しました')
          this.getMediaList('delete')
          this.isCardModalActive = false
          this.selectedMedia.data = null
        }else{
          if(r.errors.length > 0 && r.errors[0].status == 403) {
            this.$store.dispatch('promptToLogin')
            return
          } else {
            this.$common.createErrorMessage(r.errors, '画像の削除に失敗しました。時間を空けて、もう一度お試しください。')
          }
        }
      } catch (e) {
        this.$common.createErrorMessage(null, null)
      }
    },
  }
}
</script>